import { DesignationDto } from "@gtpl/shared-models/hrms";
import { FreightsCompanyRequest } from "@gtpl/shared-models/masters";
import { FreightsCompanytService } from "@gtpl/shared-services/masters";
import { AlertMessages } from "@gtpl/shared-utils/alert-messages";
import { Input, Button, Tag, Tooltip, Divider, Popconfirm, Switch, Card, Row, Col, Table, Drawer } from "antd";
import { ColumnProps } from "antd/lib/table";
import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Highlighter from 'react-highlight-words';
import {CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EditOutlined, SearchOutlined, AlertTwoTone} from '@ant-design/icons';
import FreightsCompanyForm from "./freights-company-form";

export function FreightsCompanyView(){
    const searchInput = useRef(null);
    const [page, setPage] = React.useState(1);
    const [searchText, setSearchText] = useState(''); 
    const [searchedColumn, setSearchedColumn] = useState('');
  
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [data, setData] = useState<FreightsCompanyRequest[]>([]);
    const [selectedCompany, setSelectedCompany] = useState<any>(undefined);
  
    const service = new FreightsCompanytService();
  
    useEffect(() => {
      getAll();
    },[]);
  
    /**
     * 
     */
    const getAll = () => {
      service.getAllFreightsCompanies().then(res => {
        if(res.status){
          setData(res.data);
        }else {
          if(res.intlCode){
            setData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
          }else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        setData([]);
        AlertMessages.getErrorMessage(err.message);
      })
    } 
  
    /**
     * 
     * @param DesignationData 
     */
     const deleteCompany = (req:FreightsCompanyRequest) => {
      req.isActive=req.isActive?false:true;
      service.activateDeactivateFreightCompany(req).then(res => { console.log(res);
        if (res.status) {
          getAll();
          AlertMessages.getSuccessMessage(res.internalMessage);
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
    }
  
    /**
       * 
       * @param variantData 
       */
     const update = (val: FreightsCompanyRequest) => {
        console.log(val,'000000000')
         const req = new FreightsCompanyRequest(val.id,val.name,val.code,val.linerAddress,val.isActive,val.createdAt,val.createdUser,val.updatedAt,val.updatedUser,val.versionFlag)
         console.log(req,'ooooooooo');
      service.updateFreightCompany(req).then(res => { console.log(res);
        if (res.status) {
          AlertMessages.getSuccessMessage('Updated Successfully');
          getAll();
          setDrawerVisible(false);
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
    }
  
     /**
     * used for column filter
     * @param dataIndex column data index
     */
      const getColumnSearchProps = (dataIndex:string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={ searchInput }
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </div>
        ),
        filterIcon: filtered => (
          <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
        record[dataIndex]
        ? record[dataIndex]
           .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
            : false,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {    setTimeout(() => searchInput.current.select());   }
        },
        render: text =>
          text ?(
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text.toString()}
            />
          ) :text
          )
          : null
         
      });

      function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
      };
    
        //drawer related
        const closeDrawer=()=>{
          setDrawerVisible(false);
        }
      
        //TO open the form for updation
        const openFormWithData=(viewData: FreightsCompanyRequest)=>{
          setDrawerVisible(true);
          setSelectedCompany(viewData);
        }
    
        const columnsSkelton: ColumnProps<any>[] = [
          {
            title: 'S No',
            key: 'sno',
            width: '70px',
            responsive: ['sm'],
            render: (text, object, index) => (page-1) * 10 +(index+1)
          },
          
          {
            title: 'Name',
            dataIndex: 'name',
            // responsive: ['lg'],
            sorter: (a, b) => a.name?.length - b.name?.length,
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('name')
          },
          {
            title: 'Code',
            dataIndex: 'code',
            // responsive: ['lg'],
            sorter: (a, b) => a.code?.length - b.code?.length,
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('code')
          },
          {
            title: 'Liner Address',
            dataIndex: 'linerAddress',
            // responsive: ['lg'],
            sorter: (a, b) => a.linerAddress?.length - b.linerAddress?.length,
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('linerAddress')
          },
          {
            title: 'Status',
            dataIndex: 'isActive',
            align:'center',
            render: (isActive, rowData) => (
              <>
                {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
                
              </>
            ),
            filters: [
              {
                text: 'Active',
                value: true,
              },
              {
                text: 'InActive',
                value: false,
              },
            ],
            filterMultiple: false,
            onFilter: (value, record) => 
            {
              
              return record.isActive === value;
            },
            
          },
          {
            title:`Action`,
            dataIndex: 'action',
            render: (text, rowData) => (
              <span>  
                   <Tooltip placement="top" title='Edit'>     
                  <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
                    onClick={() => {
                      if (rowData.isActive) {
                        openFormWithData(rowData);
                      } else {
                        AlertMessages.getErrorMessage('You Cannot Edit Deactivated Freight Company');
                      }
                    }}
                    style={{ color: '#1890ff', fontSize: '14px' }}
                  />
                </Tooltip>
                <Divider type="vertical" />
                  <Popconfirm onConfirm={e =>{deleteCompany(rowData);}}
                  title={
                    rowData.isActive
                      ? 'Are you sure to Deactivate ?'
                      :  'Are you sure to Activate ?'
                  }
                >
                  <Switch  size="default"
                      className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                      checkedChildren={<RightSquareOutlined type="check" />}
                      unCheckedChildren={<RightSquareOutlined type="close" />}
                      checked={rowData.isActive}
                    />
                  
                </Popconfirm>
              </span>
            )
          }
        ];

        const onChange=(pagination, filters, sorter, extra)=> {
            console.log('params', pagination, filters, sorter, extra);
          }
          const OpenFormTocreateRecord = () => {
           console.log('redirect here');
           
          }
        return (
          <Card title={<span style={{color:'white'}}>Freight Company</span>}
          style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/freights-company-form' ><Button className='panel_button' >Create </Button></Link>}
          
          >
           <br></br>
           <Row gutter={40}>
            <Col>
                <Card title={'Total Freight Companies: ' + data.length} style={{textAlign: 'left', width: 250 , height: 41,backgroundColor:'#bfbfbf'}}></Card>
                </Col>
                <Col>
                 <Card title={'Active: ' + data.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
                </Col>
                <Col>
                 <Card title={'In-Active :' + data.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
                </Col>
                </Row>
                <br></br>
                <Table
                rowKey={record => record.id}
                columns={columnsSkelton}
                dataSource={data}
                scroll = {{x:true}}
                pagination={{
                  onChange(current) {
                    setPage(current);
                  }
                }}
                onChange={onChange}
                bordered />
              <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '50%' : '85%'}
                  onClose={closeDrawer} visible={drawerVisible} closable={true}>
                  <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
                    <FreightsCompanyForm key={Date.now()}
                      updateDetails={update}
                      isUpdate={true}
                      ferightsCompanyData={selectedCompany}
                      closeForm={closeDrawer} />
                  </Card>
                </Drawer>
           </Card>
        );
}
export default  FreightsCompanyView